import { Col, Container, Row } from "react-bootstrap";
import Navbar from "../../components/Navbar/Navbar"
import Footer from '../../components/Footer/Footer';
import { useTranslation } from "react-i18next";


function MadeForYou () {

    const { i18n, t } = useTranslation();

    return (
      <Container>
          <Row> 
              <Col style={{textAlign: 'center'}} md={12}><h1>{t('ProductionAndFashion')}</h1></Col> 
              <Col style={{textAlign: 'center'}} md={12}>
                  <p>
                    {t('ProductionAndFashionText')}
                  </p>
              </Col>
          </Row>
      </Container>       
    );
}

export default MadeForYou;